<template>
    <div id="zones_app">
        <div class="container-fluid px-0">
            <div class="row no-gutters">
                <div class="col-lg-4 col-md-5 col-sm-5 col-xl-3 sidebar bg-dark-nvx">
                    <div class="sidebar-sticky accordion">

                        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center p-2">
                            <span></span>
                            <a class="btn btn-success btn-sm"
                               v-on:click="create_zone">{{$t('create_alert')}}</a>
                        </div>
                        <li class="nav-item border-bottom" style="border-color: #333 !important;">
                            <div class="nav-link" v-on:click="select_all()"
                                 v-bind:class="{'active': (selected==null) }">{{$t('all_alerts')}}
                            </div>
                        </li>
                        <li v-for="zone in zones" :key="zone.id" class="nav-item">
                            <div class="nav-link" v-bind:class="{'active': (selected&&selected.id==zone.id) }"
                                 v-on:click="select(zone)">
                                <span v-show="(!edit||!selected||selected.id!=zone.id)" v-text="zone.name"></span>
                                <span v-show="!edit&&zone.require_save">
                                    <span data-feather="alert-circle"></span>
                                </span>
                                <div class="btn-group float-right" v-show="(selected&&selected.id==zone.id)">
                                    <button class="btn btn-sm btn-primary" v-on:click="toggle_edit_mode">
                                        {{$t('edit')}}
                                    </button>
                                </div>
                            </div>
                            <div id="editInterface" v-show="edit&&selected&&selected.id==zone.id">
                                <zone-edit v-bind:zoneid="zone.id"
                                           v-bind:devices="devices"
                                           v-bind:contacts="contacts"
                                           v-bind:places="places">
                                </zone-edit>
                                <div class="row mx-2 mb-2">
                                    <button v-if="zone.id" class="btn btn-success" v-on:click="save(zone)">
                                         {{$t('Save')}}
                                    </button>
                                    <button v-if="!zone.id" class="btn btn-success" v-on:click="save(zone)">
                                         {{$t('create')}}
                                    </button>
                                    <button v-if="zone.id" class="btn btn-danger" v-on:click="will_delete(zone)">
                                         {{$t('delete')}}
                                    </button>
                                </div>
                            </div>
                        </li>
                    </div>
                </div>

                <div role="main" class="col-sm-7 col-md-7 ml-sm-auto col-lg-8  col-xl-9 mx-0">
                    <div id="map_container">
                        <div id='map'></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="zone_to_delete&&selected">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">{{$t('delete_alert')}}
                                        <span v-if="selected" v-text="selected.name"></span></h4>
                                </div>
                                <div class="modal-body">
                                    <div>{{$t('delete_condition_alert')}}<br>
                                    <h5>{{$t('delete_definitive_alert')}}</h5></div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" v-on:click="close_modal">
                                        {{$t('cancel')}}
                                    </button>
                                    <a id='delete-btn' class="btn btn-danger"
                                       v-on:click="on_delete(selected)"> {{$t('delete')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<style>
    #more::after {
        display: none
    }

    #editInterface {
        color: white;
        background: #4C4C4C;
    }
</style>

<script>
import {HTTP} from '../http-constants'
import * as nvxlib from '../nvxcommon'
import gmapsInit, {movePolygon} from "../gmaps.js"
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import ZoneEdit from "./ZoneEdit.vue"

const feather = require('feather-icons')
    var map;
    var markers = [];
    var markerCluster = null;
    var circles = [];


    export default {
        name: 'Zones',
        data() {
            return {
                selected: null,
                zones: [],
                zone_to_delete: false,
                edit: false,
                devices: [],
                places: [],
                contacts: []
            }
        },
        components:{
            'zone-edit': ZoneEdit
        },
        methods: {
            'load': function () {
                var self = this;
                nvxlib.getZones(function (zones) {
                    self.zones = zones;
                    initMap(self.zones);
                });
            },
          'select_all': function () {
            console.log("select all zones")
            this.selected = null;
            this.edit = false;
            clearZonesMarkers();
            setMarkers(map, this.zones, true);
          },
          'select': function (zone) {

            if (this.selected) {
              if (this.selected.id !== zone.id) {
                this.edit = false;
                clearZonesMarkers();
                setMarkers(map, [zone], true);
              } else {
                console.log("same zone+", zone.id);
                return;
              }
            }
            console.log("select zone", zone.id, zone.name);
            this.selected = zone;
            if (zone.polygon) {
              const coordinates = zone.polygon.coordinates[0];
              let bounds = new google.maps.LatLngBounds();
              coordinates.forEach(([lng, lat]) => {
                bounds.extend(new google.maps.LatLng(lat, lng));
              });
              map.fitBounds(bounds);
            } else {
              map.setCenter({lat: zone.lat, lng: zone.lng});
              map.setZoom(15);
            }
            this.configure_map_edit(this.edit)
          },
                'toggle_edit_mode': function() {
                    console.log("toggle_edit_mode", this.edit);
                    var new_value = !this.edit;
                    this.edit_mode(new_value);
                },
                'edit_mode': function (enable) {
                    this.edit = enable;
                    console.log("selected: ", this.selected, " edit: ", this.edit);
                    if (this.edit) {
                        if (this.selected) {
                            let _zones = [this.selected];
                            clearZonesMarkers();
                            setMarkers(map, _zones, true);
                            this.$emit('zone_edit', this.selected);
                        }
                    } else {
                        let _zones = this.zones;
                        clearZonesMarkers();
                        setMarkers(map, _zones, true);
                    }
                },
                'will_delete': function (zone) {
                    this.zone_to_delete = true;
                },
                'close_modal': function(){
                    this.zone_to_delete = false
                },
                'on_delete': function (zone) {
                    var self = this;
                    self.zone_to_delete = false
                    HTTP.delete("/tracker_zones/" + zone.id + "/", zone)
                        .then(function (re) {
                            var idx = self.zones.indexOf(zone)
                            if (idx >= 0) {
                                if (zone == self.selected){
                                    self.selected=null;
                                }
                                self.zones.splice(idx, 1);
                                clearZonesMarkers();
                                setMarkers(map, self.zones, true);
                                nvxlib.saveZones(self.zones);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                },
                'save': function (zone) {
                    var self = this;
                    console.log("Save zone old: ", zone.polygon);
                    console.log("save circles", circles);
                    if (circles.length > 0) {
                      if (zone.polygon) {
                        console.log("update polygon");
                        zone.polygon = polygon_from_polylines(zone, circles[0])
                        const center = this.center_from_polylines(circles[0]);
                        zone.lat = center.lat();
                        zone.lng = center.lng();
                        console.log("zone new", zone.polygon);
                      }
                    }
                    if (!zone.id) {
                        HTTP.post('/tracker_zones/', zone)
                            .then(function (re) {
                                var idx = self.zones.indexOf(zone)
                                if (idx >= 0) {
                                    self.zones[idx] = re.data;
                                    self.selected = self.zones[idx];
                                    nvxlib.saveZones(self.zones);
                                }
                                self.edit_mode(false);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    } else {
                        HTTP.patch('/tracker_zones/' + zone.id + '/', zone)
                            .then(function (re) {
                                var idx = self.zones.indexOf(zone)
                                if (idx >= 0) {
                                    self.zones[idx] = re.data;
                                    self.selected = self.zones[idx];
                                    nvxlib.saveZones(self.zones);
                                }
                                self.edit_mode(false);
                            })
                            .catch(function (error) {
                                console.log("error", error);
                            });
                    }
                },
                'create_zone': function () {
                    var zone = {
                        id: null,
                        lat: 48.85,
                        lng: 2.34,
                        radius: 200,
                        mode: 'zoneinout',
                        name: app.$t('new_alert'),
                    };
                    zone.devices = [];
                    zone.contacts = [];
                    zone.require_save=true;
                    var new_zones = this.zones.filter(elem => elem.id == null);
                    if (new_zones.length > 0){
                        zone = new_zones[0];
                    } else {
                        this.zones.push(zone);
                        this.$forceUpdate();
                    }
                    this.selected = zone;
                    this.edit_mode(false);
                },
            'load_contacts': function () {
                var self = this;
                HTTP.get('/alertcontacts/',)
                    .then(function (re) {
                        self.contacts = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'load_devices': function () {
                var self = this;
                nvxlib.getDevices(function (devices) {
                    if (devices.length) {
                        self.devices = devices;
                    }
                });
            },
            'load_places': function () {
                var self = this;
                HTTP.get('/tracker_places/',)
                    .then(function (re) {
                        self.places = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
          polygon_from_polylines(zone, circle) {
            const path = circle.getPath().getArray().map(coord => [coord.lng(), coord.lat()]);
            if (path.length && (path[0][0] !== path[path.length - 1][0] || path[0][1] !== path[path.length - 1][1])) {
              path.push(path[0]);
            }
            return {
              type: "Polygon",
              coordinates: [path]
            };

          },
          center_from_polylines(circle) {
            const bounds = new google.maps.LatLngBounds();

            circle.getPath().getArray().map(coord => {
              bounds.extend(coord);
            });
            //console.log(bounds.getCenter());
            return bounds.getCenter();
          },
            'configure_map_edit': function (editing) {
              console.log("configure_map_edit with editing", editing);

                if (editing) {
                  var self = this;
                  const marker = markers[0];
                  const circle = circles[0];

                  console.log("configure_map_edit", circle);
                  if (circle instanceof google.maps.Polygon) {
                    console.log("edit polygon");
                    circle.setEditable(true);
                    circle.setDraggable(true);
                    google.maps.event.addListener(circle, 'dragend', function (event) {
                      console.log("dragend polygon", self.selected, event, circle);
                      if (self.selected && self.edit) {
                        const center = self.center_from_polylines(circle);
                        console.log("dragend polygon", center.lat(), center.lng());
                        self.selected.lat = center.lat();
                        self.selected.lng = center.lng();
                        marker.setPosition(center);
                        self.$emit('zone_edit', self.selected);
                      }
                    });
                    google.maps.event.addListener(circle, 'drag', function (event) {
                      const center = self.center_from_polylines(circle);
                      marker.setPosition(center);
                    });
                  } else {
                    marker.setDraggable(true);
                  }

                    google.maps.event.addListener(marker, 'dragend', function (event) {
                        var selected = self.selected;
                        console.log("dragend", selected, event, circle);
                        if (selected && self.edit) {
                            selected.lat = this.position.lat();
                            selected.lng = this.position.lng();
                            self.$emit('zone_edit', selected);
                        }
                        circle.setCenter(this.position);
                    });
                    google.maps.event.addListener(marker, 'drag', function (event) {
                        circle.setCenter(this.position);
                    });
                } else {
                    for (let i = 0; i < markers.length; i++) {
                        let marker = markers[i];
                        marker.setDraggable(false);
                    }
                }
            }
        },
        async mounted() {
            const google = await gmapsInit();
            this.load_contacts();
            this.load_places();
            this.load_devices();
            this.load();
            this.$on('zone_move', zone => {
                let marker = markers[0];
                let circle = circles[0];
                console.log("zone_move", zone);
                console.log("marker", marker);
                console.log("circle", circle);
                const position = {lat: zone.lat, lng: zone.lng};
                marker.setPosition(position);
                if (zone.polygon){
                  movePolygon(circle, position);
                } else {
                  circle.setCenter(position);
                }
                resizeMap(map, [zone]);
            });
            this.$on("zone_resize", zone => {
                circles[0].setRadius(Number(zone.radius));
            });
            this.$on("zone_rename", zone => {
                let marker = markers[0];
                let label = marker.label;

                if (zone.name.length)
                    label.text = zone.name;
                else
                    label.text = "<zone>";
                marker.setLabel(label);
            });
            this.$on('zone_changed', zone => {
                console.log("zone_changed", zone);
                this.selected = zone;
                this.edit_mode(true);
                this.configure_map_edit(true);
            });
        },
        updated: function () {
            feather.replace();
        }
    }



    function initMap(zones) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 10,
            scaleControl: true,
            streetViewControl: true,
        });

        setMarkers(map, zones, true);
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearZonesMarkers() {
      console.log("clearZonesMarkers", markers.length);
      if (markerCluster) {
        markerCluster.clearMarkers();
        markerCluster = null;
      }

      markers.forEach(marker => {
        google.maps.event.clearInstanceListeners(marker);
        marker.setMap(null);

      });
     markers = [];
      for (let j = 0; j < circles.length; j++) {
        circles[j].setMap(null);
      }
      circles = [];
    }

    function resizeMap(map, zones) {
      console.log("resizeMap zones", zones.length);
      console.log("resizeMap circles", circles.length);
        if (zones.length == 0){
            map.setCenter({lat:48.85, lng:2.34});
            return
        }

        var bounds = new google.maps.LatLngBounds();

        for (let i = 0; i < zones.length; i++) {
            let zone = zones[i];
            if (zone.polygon && circles.length > i){
           //  console.log("resizeMap", zone.name);
              let polygon = circles[i];
            //  console.log("polygon", polygon);
              polygon.getPath().forEach((latlng) => {
                bounds.extend(latlng);
              });

            } else {
              var point = {lat: zone.lat, lng: zone.lng};
              bounds.extend(point);
            }
        }
        google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
         // console.log("bounds_changed", map.getZoom());
            this.setZoom(Math.min(15, this.getZoom()));
        });
        map.fitBounds(bounds)
    }

    function setMarkers(map, zones, resize) {

      console.log("setMarkers", zones.length, resize);

      for (let i = 0; i < zones.length; i++) {
        const zone = zones[i];

        const icon = {
          url: "/js/gmaps/" + "zone-center.png",
          scaledSize: new google.maps.Size(10, 10),
          labelOrigin: new google.maps.Point(10, -5),
          anchor: new google.maps.Point(5, 5)
        }
        const label = {
          text: zone.name,
          fontSize: '12px',
          color: 'blue'
        };

        let marker = new google.maps.Marker({
          position: {lat: zone.lat, lng: zone.lng},
          map: map,
          title: zone.name,
          label: label,
          icon: icon
        });
        markers.push(marker)

        if (zone.polygon) {
          console.log("zone", zone.name);
          const paths = zone.polygon.coordinates[0].map(coord => {
            return {lat: coord[1], lng: coord[0]}
          });

          const polygon = new google.maps.Polygon({
            paths: paths,
            strokeColor: '#0000FF',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#0000FF',
            fillOpacity: 0.35,
            map:map
          });
          circles.push(polygon);
        } else {
          var circle = new google.maps.Circle({
            strokeColor: '#0000FF',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#0000FF',
            fillOpacity: 0.35,
            map: map,
            center: {lat: zone.lat, lng: zone.lng},
            radius: Number(zone.radius)
          });
          circles.push(circle);
        }

        if (resize) {
          resizeMap(map, zones)
        }
        if (markers.length >1 && !markerCluster) {
          console.log("Init new MarkerClusterer");
          const mcOptions = {gridSize: 70, maxZoom: 13, markers: markers, map: map};
          markerCluster = new MarkerClusterer(mcOptions);
        }
      }
    }

</script>